// extracted by mini-css-extract-plugin
module.exports = {"mobileBreakpoint":"600px","tabletBreakpoint":"1040px"};